import type { SxStyle } from '@aibees/shared/theme';

export const root: SxStyle = {
  height: (p) => p.spacing(5),
};
